var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tagNm || 'span',{tag:"component"},[_c('span',{staticClass:"name"},[_vm._v(" "+_vm._s(_vm.data.tecMberNm || _vm.data.mberNm)+" ("+_vm._s(_vm._f("gender")(_vm.data.gender))+") "),_vm._t("after",[_vm._v(_vm._s(_vm.after))])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }